import React from 'react';

const ChevronUp: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    data-test-id={'basket_summary_open'}
    width="16"
    height="9"
    viewBox="0 0 16 9"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14.9137 8.16344C14.8266 8.25084 14.7231 8.32018 14.6092 8.3675C14.4952 8.41482 14.3731 8.43917 14.2497 8.43917C14.1263 8.43917 14.0041 8.41482 13.8902 8.3675C13.7762 8.32018 13.6727 8.25084 13.5856 8.16344L8.00045 2.57828L2.41374 8.16344C2.23762 8.33956 1.99874 8.4385 1.74967 8.4385C1.5006 8.4385 1.26173 8.33956 1.08561 8.16344C0.90949 7.98732 0.810547 7.74844 0.810547 7.49937C0.810547 7.2503 0.90949 7.01143 1.08561 6.83531L7.33561 0.585309C7.42271 0.497909 7.5262 0.428562 7.64016 0.381245C7.75411 0.333927 7.87628 0.30957 7.99967 0.30957C8.12306 0.30957 8.24524 0.333927 8.35919 0.381245C8.47315 0.428562 8.57664 0.497909 8.66374 0.585309L14.9137 6.83531C15.0011 6.92241 15.0705 7.0259 15.1178 7.13986C15.1651 7.25381 15.1895 7.37598 15.1895 7.49937C15.1895 7.62276 15.1651 7.74494 15.1178 7.85889C15.0705 7.97285 15.0011 8.07634 14.9137 8.16344Z"
      fill="#E82026"
    />
  </svg>
);

export default ChevronUp;
